
// import Accordion from './Accordion';
import BusRatesTable from './BusRatesTable';
// import CustomCarousel from './CustomCarousel';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import { Link } from 'react-router-dom';
// import FAQSection from './FAQSection';
import FAQItem from './FAQItem';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Cabserviceinvimannagar() {



  const cardData =
  {
    keyword: 'Cab Service in Viman Nagar',
    heading: 'AB Ghule Cabs: Cab Service in Viman Nagar',
    headingDescription: 'Traveling in and around Viman Nagar? AB Ghule Cabs provides reliable, comfortable, and affordable cab services tailored to your needs. Whether it’s a local ride, an airport transfer, or a long-distance journey, our professional service ensures a smooth and hassle-free experience.',

    top: 'Top Places to Visit in Mumbai with AB Ghule Cabs',

    "topPlaces": [
        {
          title: "Phoenix Marketcity",
          description: "One of the largest shopping malls in Pune, Phoenix Marketcity offers a variety of shopping, dining, and entertainment options. It also has a multiplex for movie lovers and hosts regular events."
        },
        {
          title: "Jogger’s Park",
          description: "A peaceful park located in Viman Nagar, ideal for a morning jog, evening walks, or just relaxing amidst nature. The park has beautiful landscaping and open spaces."
        },
        {
          title: "ISKCON Viman Nagar",
          description: "The International Society for Krishna Consciousness temple, located in Viman Nagar, is a serene place for spiritual activities, meditation, and devotion. The temple offers a peaceful ambiance and cultural events."
        },
        {
          title: "GigaSpace",
          description: "A well-known business and tech hub in the area, GigaSpace is not typically a tourist spot but offers a unique view of Pune’s growing tech industry and a great place for business travelers to explore."
        },
        {
          title: "Vishal Mega Mart",
          description: "Located in the Viman Nagar area, this is a great place for shopping with a variety of products ranging from clothes to home goods at affordable prices."
        },
        {
          title: "Kalyani Nagar Gardens",
          description: "A short distance from Viman Nagar, Kalyani Nagar Gardens is a peaceful location with walking trails and greenery. It is a lovely place for a stroll or a quiet afternoon."
        },
        {
          title: "Osho Garden (Koregaon Park)",
          description: "Situated a short drive from Viman Nagar, Osho Garden offers lush greenery and tranquility. It’s a perfect spot for meditation, yoga, or just escaping the hustle and bustle of the city."
        },
        {
          title: "Aga Khan Palace",
          description: "Located about 15 minutes from Viman Nagar, the Aga Khan Palace is a historical landmark famous for its architecture and connection to India’s freedom struggle. It’s a must-visit for history buffs."
        },
        {
          title: "Pune-Okayama Friendship Garden (Pu La Deshpande Garden)",
          description: "A beautiful Japanese-style garden located in the vicinity, perfect for nature lovers and those seeking a quiet retreat to enjoy scenic views and relaxing walks."
        },
        {
          title: "Koregaon Park",
          description: "Known for its lively atmosphere, Koregaon Park, located just a short distance from Viman Nagar, is famous for cafes, restaurants, art galleries, and a peaceful ambiance, making it a popular spot for both locals and tourists."
        }
      ],


      services: [
        {
          "name": "Taxi Service in Viman Nagar",
          description: "Looking for a taxi service in Viman Nagar? Whether you're heading to Pune Airport, going to a local destination, or traveling to nearby areas, our reliable taxi services cater to all your needs. We offer a wide range of vehicles including sedans, SUVs, and luxury cars, ensuring a comfortable and affordable journey. Our professional drivers ensure punctuality and safety for all your trips."
        },
        {
          "name": "Taxi Service in Wadgaon Sheri",
          description: "Taxi services in Wadgaon Sheri are available 24/7. Our professional drivers are ready to take you to any destination, be it local sightseeing, airport transfers, or outstation trips. Whether you're traveling for business or leisure, we provide safe and punctual services. We ensure that your travel experience is comfortable and hassle-free."
        },
        {
          "name": "Cabs Booking in Chandan Nagar",
          description: "Booking a cab in Chandan Nagar is easy and hassle-free. Whether you need a sedan, SUV, or luxury car, our cabs are well-maintained and perfect for all types of travel, including airport pick-ups, corporate events, and family trips. We ensure a smooth and reliable ride to your desired destination."
        },
        {
          "name": "Taxi Booking in Kalyani Nagar",
          description: "If you're in Kalyani Nagar, you can easily book a taxi for any location with us. We provide affordable taxi bookings with a focus on convenience and comfort. We offer both local and outstation cab services to suit your needs, including rides to Pune Airport and Shirdi. Our efficient and professional drivers ensure you reach your destination on time."
        },
        {
          "name": "Taxi Service in Koregaon Park",
          description: "Koregaon Park is a vibrant area in Pune, and we provide the best taxi services in Koregaon Park. Whether you're traveling to work, going for sightseeing, or heading to the airport, our taxis are available for all your needs. Our fleet includes Innova, Ertiga, and Swift Dzire, perfect for family trips or corporate travel. We offer reliable and punctual services at competitive rates."
        },
        {
          "name": "Taxi Service at Pune Airport",
          description: "Need a taxi from Pune Airport? We offer airport pick-up and drop-off services at the Pune Airport. Whether you're arriving from domestic or international flights, we provide smooth and comfortable taxi services for all your travel needs. We also offer one-way taxi options for seamless transfers. Our professional drivers ensure timely service and a comfortable journey."
        },
        {
          "name": "Innova Crysta on Rent in Viman Nagar",
          description: "Looking for an Innova Crysta on rent in Viman Nagar? We offer luxury and spacious Innova Crysta cabs for local and outstation trips. Whether you're planning a family vacation, corporate trip, or an outstation tour, our Innova Crysta rental service ensures comfort and safety throughout your journey. Travel in style with our well-maintained vehicles."
        },
        {
          "name": "Ertiga on Rent in Viman Nagar",
          description: "For a comfortable ride, hire an Ertiga on rent in Viman Nagar. Ideal for family trips and local travel, the Ertiga offers ample space and fuel efficiency. You can book the Ertiga rental for both short trips within Pune and outstation journeys. It's the perfect choice for affordable, comfortable travel."
        },
        {
          "name": "Tempo Traveller Hire in Viman Nagar",
          description: "Need a Tempo Traveller in Viman Nagar? We provide Tempo Traveller rentals for group travel, events, and long-distance trips. Whether you're traveling with family or colleagues, our Tempo Traveller hire ensures a comfortable and safe journey. Our well-maintained vehicles cater to all your group travel needs."
        },
        {
          "name": "Mini Bus on Rent in Viman Nagar",
          description: "For larger groups, we offer mini buses on rent in Viman Nagar. Whether you're planning a corporate outing, a wedding, or a group tour, our mini buses accommodate large groups comfortably, ensuring everyone has a pleasant journey. Our buses are well-maintained and come with professional drivers for a smooth travel experience."
        },
        {
          "name": "Sedan Cab Hire for Outstation in Viman Nagar",
          description: "Looking to hire a sedan for an outstation trip from Viman Nagar? We provide sedan cabs for your outstation travel needs, whether it’s a trip to Lonavala, Mahabaleshwar, Shirdi, or any other nearby destination. Enjoy a smooth ride with our experienced drivers who know the best routes and ensure timely arrivals."
        },
        {
          "name": "Innova Cabs on Rent in Viman Nagar",
          description: "Our Innova cabs on rent in Viman Nagar are perfect for family trips, group travel, and outstation tours. We provide clean and comfortable vehicles with professional drivers who ensure your journey is pleasant and safe. Choose our Innova cabs for a spacious and comfortable ride."
        },
        {
          "name": "Viman Nagar to Shirdi Cabs Services",
          description: "Planning a trip from Viman Nagar to Shirdi? We offer reliable cab services from Viman Nagar to Shirdi, ensuring a comfortable and hassle-free journey. Our drivers are familiar with the best routes to Shirdi, ensuring a timely arrival. Whether it’s a religious trip or leisure, we offer a smooth and pleasant ride."
        },
        {
          "name": "Cab Service in Yerwada",
          description: "Looking for a cab service in Yerwada? We provide reliable taxi services to and from Yerwada, whether you're traveling for business, airport transfers, or outstation trips. Our fleet includes luxury cars, sedans, and SUVs, ensuring comfort and convenience for all your travel needs."
        },
        {
          "name": "Cab Service in Viman Nagar Contact Number",
          description: "Contact AB Ghule Cabs at +91 8624029699 for prompt and efficient Cab Service in Viman Nagar. We ensure a smooth and enjoyable ride for all our customers. Whether you need a taxi for a short trip, airport transfer, or outstation journey, we are always ready to serve you."
        }
      ],

      tableData: [
        ["Taxi service Viman Nagar", "-Taxi Service in Wadgaon Sheri"],
        ["Cabs Booking in Chandan Nagar", "-Taxi booking in Kalyani Nagar"],
        ["Taxi Service in Koregaon Park", "-Taxi service in Pune airport"],
        ["Innova Crysta on rent in Viman Nagar", "-Ertiga on rent in Viman Nagar"],
        ["Tempo traveller hire in Viman Nagar", "-Mini bus on rent in Viman Nagar"],
        ["Sedan cab hire for outstation in Viman Nagar", "-Innova cabs on rent in Viman Nagar"],
        ["Viman Nagar to Shirdi cabs services", "-Cab service in Yerwada"]
      ],
      
      whychoose: [
        {
          WhyChooseheading: "Reliable and Professional Service",
          WhyChoosedescription: "At AB Ghule Cabs, we offer reliable and professional cab services in Viman Nagar. Our drivers are experienced, friendly, and dedicated to providing you with a smooth and safe ride."
        },
        {
          WhyChooseheading: "24/7 Availability",
          WhyChoosedescription: "No matter the time of day or night, our services are available 24/7. Whether you need a cab for early morning travel or late-night trips, our customer service team is ready to assist you with your booking."
        },
        {
          WhyChooseheading: "Affordable Rates",
          WhyChoosedescription: "We provide transparent and competitive pricing. With AB Ghule Cabs, you can travel comfortably within your budget. We ensure no hidden charges, and our fares are designed to suit solo travelers or group bookings."
        },
        {
          WhyChooseheading: "Clean and Well-Maintained Fleet",
          WhyChoosedescription: "Our fleet consists of clean, well-maintained vehicles that are regularly inspected for safety and comfort. Whether you need a standard sedan or a luxury car, we have a variety of options available to suit your needs."
        },
        {
          WhyChooseheading: "Safe and Comfortable Rides",
          WhyChoosedescription: "Your safety is our top priority. We ensure that all our drivers are background-checked, and our vehicles are equipped with GPS for smooth navigation. Expect a comfortable and safe journey every time you choose us."
        },
        {
          WhyChooseheading: "Easy Booking Process",
          WhyChoosedescription: "Booking a cab is easy with AB Ghule Cabs. You can book your cab through our website, mobile app, or simply call our customer service team for immediate assistance."
        },
        {
          WhyChooseheading: "Customer Satisfaction",
          WhyChoosedescription: "We are proud to have a loyal customer base who regularly praise our services. Our goal is to provide a seamless travel experience, ensuring customer satisfaction with every ride."
        }
      ]
      
  

  }

  const faqData = [
    {
      id: 'FAQ1',
      question: 'How can I book a cab in Viman Nagar with AB Ghule Cabs?',
      answer: 'You can book a cab through our website, mobile app, or by calling our customer service helpline for assistance.',
    },
    {
      id: 'FAQ2',
      question: 'Are your drivers experienced and trustworthy?',
      answer: 'Yes, all of our drivers are highly trained, experienced, and thoroughly background-checked to ensure your safety.',
    },
    {
      id: 'FAQ3',
      question: 'What types of vehicles are available for booking?',
      answer: 'We offer a wide range of vehicles including sedans, SUVs, and luxury cars to suit your travel needs.',
    },
    {
      id: 'FAQ4',
      question: 'How do I pay for my ride?',
      answer: 'You can pay via cash, credit/debit card, or online payment through our app, offering you multiple convenient payment options.',
    },
    {
      id: 'FAQ5',
      question: 'Are there any additional charges for waiting or detours?',
      answer: 'There may be additional charges for waiting time or detours, but we ensure full transparency. Any extra charges will be communicated to you in advance.',
    },
    {
      id: 'FAQ6',
      question: 'Can I cancel or modify my booking?',
      answer: 'Yes, you can easily cancel or modify your booking through our website or app. Our customer service team is also available to assist you with any changes.',
    },
    {
      id: 'FAQ7',
      question: 'Do you offer one-way and round-trip services?',
      answer: 'Yes, we offer both one-way and round-trip services, depending on your travel requirements.',
    },
    {
      id: 'FAQ8',
      question: 'Is AB Ghule Cabs available for group travel?',
      answer: 'Absolutely! We offer spacious vehicles for group travel, ensuring that your group travels comfortably to any destination.',
    },
    {
      id: 'FAQ9',
      question: 'What makes AB Ghule Cabs different from other cab services?',
      answer: 'AB Ghule Cabs stands out due to its exceptional customer service, professional drivers, a range of vehicle options, and affordable prices. We are committed to providing a personalized, safe, and stress-free experience for every passenger.',
    },
  ];
  
  const testimonials = [
    {
      id: 1,
      name: 'Mr. Arun Deshmukh',
      feedback: 'I’ve been using AB Ghule Cabs for my regular trips in and around Viman Nagar. The service is always punctual, the drivers are courteous, and the vehicles are clean and comfortable. Highly recommended!',
      rating: 5,
    },
    {
      id: 2,
      name: 'Ms. Priya Shah',
      feedback: 'AB Ghule Cabs made my trip to the airport hassle-free. The booking process was simple, the driver was professional, and I arrived on time. Excellent service overall!',
      rating: 5,
    },
  ];
  
  






  const carouselItems = testimonials.map(testimonial => (
    <div key={testimonial.name}>
      <blockquote>

        <p className='testi'>   <span className="quote">“</span>{testimonial.text}</p>
        <footer className=' user'>— {testimonial.name}</footer>
      </blockquote>
    </div>
  ));

  const carouselOptions = {
    loop: true,
    margin: 10,
    nav: true,
    items: 1
  };

  const contactData = {
    heading: `${cardData.keyword} Contact Number`,
    contactNumbers: [
      "+91 8624029699",
      

    ],
    email: "booking@abghulecabs.com"
  };


  const Images = [
    {
      place: "/images/keyword/1.jpg",
      text: "Mumbai Cab Service",
    },
    {
      place: "/images/keyword/2.jpg",
      text: "Mumbai to Shirdi Cab",
    },
    {
      place: "/images/keyword/3.jpg",
      text: "Mumbai Darshan Cabs",
    },
    {
      place: "/images/keyword/4.jpg",
      text: "Mumbai to Vadodara Taxi",
    },
    {
      place: "/images/keyword/5.jpg",
      text: "Mumbai to Pune Cab",
    },
    {
      place: "/images/keyword/6.jpg",
      text: " Mumbai to Goa Taxi",
    },
    {
      place: "/images/keyword/7.jpg",
      text: "Mumbai Airport Cab",
    },

    {
      place: "/images/keyword/8.jpg",
      text: "Mumbai Surat Cabs",
    },

    {
      place: "/images/keyword/9.jpg",
      text: "Mumbai to Mahabaleshwar Cab",
    },
    {
      place: "/images/keyword/10.jpg",
      text: "Mumbai to Konkan Cab",
    },

    {
      place: "/images/keyword/11.jpg",
      text: "Pune Cab Service",
    },
    {
      place: "/images/keyword/12.jpg",
      text: "Pune Taxi Hire",
    },

    {
      place: "/images/keyword/13.jpg",
      text: "Pune Online Cab Booking",
    },

    {
      place: "/images/keyword/14.jpg",
      text: "Best Cab Service in Pune",
    },
    {
      place: "/images/keyword/15.jpg",
      text: "Pune to Mumbai Cabs",
    },
    {
      place: "/images/keyword/16.jpg",
      text: "Pune to Nashik Cabs",
    },
    {
      place: "/images/keyword/17.jpg",
      text: "Pune to Mahabaleshwar Cabs",
    },
    {
      place: "/images/keyword/18.jpg",
      text: "Pune to Lonavala Cabs",
    },
    {
      place: "/images/keyword/19.jpg",
      text: "Pune to Shirdi Cab",
    },
    {
      place: "/images/keyword/20.jpg",
      text: "Pune to Lavasa city cabs",
    },
    {
      place: "/images/keyword/21.jpg",
      text: "Pune to Bhimashankar Cab",
    },
    {
      place: "/images/keyword/22.jpg",
      text: "Pune to Indore Cabs",
    },
    {
      place: "/images/keyword/23.jpg",
      text: "Pune to Konkan Darshan Cabs",
    },
    {
      place: "/images/keyword/24.jpg",
      text: "Pune Outstation Cabs",
    },
    {
      place: "/images/keyword/25.jpg",
      text: "Pune to Panchgani Cab Fare",
    },
    {
      place: "/images/keyword/26.jpg",
      text: "Pune to Mumbai International Airport Cab",
    },
    {
      place: "/images/keyword/27.jpg",
      text: "Ashtavinayak Darshan Cab",
    },
  ];


  const images = [
    { src: "/images/our-fleet/1.jpg", alt: "Image 1" },
    { src: "/images/our-fleet/2.jpg", alt: "Image 2" },
    { src: "/images/our-fleet/3.jpg", alt: "Image 3" },
    { src: "/images/our-fleet/4.jpg", alt: "Image 4" },
    { src: "/images/our-fleet/5.jpg", alt: "Image 5" },
    { src: "/images/our-fleet/6.jpg", alt: "Image 6" },
    { src: "/images/our-fleet/7.jpg", alt: "Image 7" },
    { src: "/images/our-fleet/8.jpg", alt: "Image 8" },
    { src: "/images/our-fleet/9.jpg", alt: "Image 9" },
  ];





  return (
    <div>
      <Helmet>
  <title>Contact: +91 8624029699 | AB Ghule Cabs | Cab Service in Viman Nagar | Reliable & Affordable Cabs</title>
  <meta name="description" content="Book reliable and affordable cab service in Viman Nagar with AB Ghule Cabs. 24/7 taxi service for local and outstation trips. Call +91 8624029699 for bookings." />
  <meta name="keywords" content="taxi service viman nagar, Taxi Service in Wadgaon Sheri, Cabs Booking in Chandan nagar, taxi booking in kalyani nagar, Taxi Service in koregaon park, taxi service in pune airport, innova crysta on rent in viman nagar, ertiga on rent in viman nagar, tempo traveller hire in viman nagar, mini bus on rent in viman nagar, sedan cab hire for outstation in viman nagar, innova cabs on rent in viman nagar, viman nagar to shirdi cabs services, cab service in yerwada" />
  <meta name="robots" content="index, follow" />
  <meta property="og:title" content="Contact: +91 8624029699 | AB Ghule Cabs | Cab Service in Viman Nagar | Reliable & Affordable Cabs" />
  <meta property="og:description" content="Book reliable and affordable cab service in Viman Nagar with AB Ghule Cabs. 24/7 taxi service for local and outstation trips. Call +91 8624029699 for bookings." />
  <meta property="og:image" content="https://abghulecabs.com/images/cab-service-viman-nagar.jpg" />
  <meta property="og:url" content="https://abghulecabs.com/cab-service-viman-nagar" />
  <meta property="og:type" content="website" />
  <meta property="og:site_name" content="AB Ghule Cabs" />

  <script type="application/ld+json">
    {`
      {
        "@context": "https://schema.org",
        "@type": "LocalBusiness",
        "name": "AB Ghule Cabs - Cab Service in Viman Nagar",
        description: "Book reliable and affordable cab service in Viman Nagar with AB Ghule Cabs. 24/7 taxi service for local and outstation trips. Call +91 8624029699 for bookings.",
        "address": {
          "@type": "PostalAddress",
          "streetAddress": "Viman Nagar, Pune, Maharashtra",
          "addressLocality": "Pune",
          "addressRegion": "Maharashtra",
          "postalCode": "411014",
          "addressCountry": "IN"
        },
        "telephone": "+91-8624029699",
        "url": "https://abghulecabs.com/cab-service-viman-nagar",
        "logo": "https://abghulecabs.com/images/cab-service-viman-nagar.jpg",
        "image": "https://abghulecabs.com/images/cab-service-viman-nagar.jpg",
        "priceRange": "₹1000 - ₹5000",
        "offers": {
          "@type": "Offer",
          "url": "https://abghulecabs.com/cab-service-viman-nagar",
          "priceCurrency": "INR",
          "price": "1000",
          "priceValidUntil": "2024-12-31"
        },
        "aggregateRating": {
          "@type": "AggregateRating",
          "ratingValue": "4.8",
          "reviewCount": "150"
        },
        "review": [
          {
            "@type": "Review",
            "author": {
              "@type": "Person",
              "name": "Ravi S"
            },
            "datePublished": "2024-10-20",
            "reviewBody": "Reliable taxi service in Viman Nagar. Used them for a trip to the airport. Comfortable ride and great driver."
          },
          {
            "@type": "Review",
            "author": {
              "@type": "Person",
              "name": "Simran T"
            },
            "datePublished": "2024-09-10",
            "reviewBody": "AB Ghule Cabs provided excellent service. I rented an Innova for an outstation trip. The driver was courteous and punctual."
          }
        ],
        "serviceArea": {
          "@type": "Place",
          "name": "Viman Nagar and Surrounding Areas Taxi Service",
          "geo": {
            "@type": "GeoCoordinates",
            "latitude": "18.5950",
            "longitude": "73.9270"
          }
        },
        "availableChannel": {
          "@type": "ServiceChannel",
          "serviceUrl": "https://abghulecabs.com/cab-service-viman-nagar"
        },
        "keywords": "taxi service viman nagar, Taxi Service in Wadgaon Sheri, Cabs Booking in Chandan nagar, taxi booking in kalyani nagar, Taxi Service in koregaon park, taxi service in pune airport, innova crysta on rent in viman nagar, ertiga on rent in viman nagar, tempo traveller hire in viman nagar, mini bus on rent in viman nagar, sedan cab hire for outstation in viman nagar, innova cabs on rent in viman nagar, viman nagar to shirdi cabs services, cab service in yerwada"
      }
    `}
  </script>
</Helmet>

      <section id="about" className="jarallax text-light">
        <div className="center-y relative text-center">
          <div className="container">
            <div className="row">
              <div className="col-md-12 text-center">
                <h1 className='text-white'>{cardData.keyword}</h1>
              </div>
              <div className="clearfix"></div>
            </div>
          </div>
        </div>
      </section>

      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 ">
              <img src='/images/keyword/59.jpg' alt='img' />
              <h3 className="py-1"
                style={{
                  color: '#FF4101', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="">
                <p className='fw-bold py-3 darkcolor'>{cardData.top}</p>
                {cardData.topPlaces.map((place, index) => (
                  <div key={index} className="">
                    <div
                      style={{
                        cursor: 'pointer',
                        padding: '10px',
                        marginBottom: '7px',
                        borderRadius: '8px',
                        transition: 'transform 0.2s'
                      }}

                    >
                      <h4 className="mb-1 darkcolor">{place.title}</h4>
                      <p className="mb-0">{place.description}</p>
                    </div>
                  </div>
                ))}
              </div>
              <div
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  marginBottom: '7px',
                  borderRadius: '8px', // Optional: rounded corners
                  transition: 'transform 0.2s' // Optional: smooth scaling effect
                }}
              >
                {cardData.services.map((service, index) => (
                  <div key={index} className=" my-4">
                    <h4 className="py-1 darkcolor">{service.name}</h4>
                    <p>{service.description}</p>
                  </div>
                ))}
              </div>

              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section"
                className='px-2'>
                {cardData.whychoose.map((item, index) => (
                  <div key={index}>
                    <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                    <p>{item.WhyChoosedescription}</p>
                  </div>
                ))}
              </div>


              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Ab Ghule Cabs</h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        {faqData.map((faq) => (
                          <FAQItem key={faq.id} id={faq.id} question={faq.question} answer={faq.answer} />
                        ))}
                      </div>
                    </div>
                  </div>
                </div>
              </div>


              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <div>

                <div className="contact-box Borderr">
                  <h3>{contactData.heading}</h3>
                  <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                  <div className="contact-details">
                    <p><strong className='darkcolor'>Mobile No:</strong></p>
                    <ul>
                      {contactData.contactNumbers.map((number, index) => (
                        <li key={index}>
                          <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                            {number}
                          </a>
                        </li>
                      ))}
                    </ul>
                    <p><strong className='darkcolor'>Email Id: </strong>
                      <a href={`mailto:${contactData.email}`} className="contact-link">
                        {contactData.email}
                      </a>
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className='col-12 col-md-4' >
              {Images.map((e) => {
                return (
                  <div className="box1">
                    <a
                      href="./"
                      className="d-flex justify-content-around align-items-center"
                    >
                      <div className="b1">
                        <img src={e.place} alt="img" />
                      </div>
                      <div className="b2">
                        {" "}
                        <a href="./" className='px-3'>{e.text}</a>
                      </div>
                    </a>
                  </div>
                );
              })}


              <div className="gallery-container">
                <h2 className="gallery-title">Our Fleets</h2>
                <div className="gallery-row d-flex flex-wrap">
                  {images.map((image, index) => (
                    <div className="gallery-item col-md-4" key={index}>
                      <img
                        src={image.src}
                        alt={image.alt}
                        className="gallery-image"

                      />
                    </div>
                  ))}
                  {/* <Link to='/gallery' className=' border radius-5 bg-redd p-3 text-white rounded-5 '>
                    See Gallery
                  </Link> */}
                </div>
              </div>

              <div className=" rounded p-4 shadow-sm Uni_border "
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  border: '3px dotted #FF4101',
                  marginBottom: '7px',
                  fontWeight: 'bold',
                }}

              >
                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                <div className="row">

                  <div className="col-12 mb-3">
                    <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#FF4101' }}>
                      <h4 className=" lead fw-semibold whitt text-dark">Phone Numbers</h4>
                      <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                      <div className=''>
                        <a href="tel:+91 8624029699" className="d-block  text-white">+91 8624029699</a>
                        

                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3 ">
                    <div className="Small_border rounded text-center">
                      <i className="bi bi-envelope fs-1 mb-2"></i>
                      <div className='rounded py-2' style={{ backgroundColor: '#FF4101' }}>
                        <h4 className=" fw-semibold lead whitt text-dark">Email</h4>
                        <a href="mailto:booking@abghulecabs.com" className=" text-white d-block">
                          booking@abghulecabs.com
                        </a>
                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3 ">
                    <div className="Small_border  rounded text-center">
                      <i className="bi bi-house-fill fs-1 mb-2"></i>
                      <div className='rounded py-2' style={{ backgroundColor: '#FF4101' }}>
                        <h4 className=" fw-semibold lead whitt text-dark">Address</h4>
                        <p className="whit text-white ">
                          <i> AB Ghule Cabs<br />
                            R -10 Office No -1606,   <br />
                            Life Republic Mulshi, Marunji  <br />
                            Pune, Maharashtra - 411057.

                          </i>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>



            </div>
          </div>
        </div>
      </section>






    </div>
  );
}

export default Cabserviceinvimannagar;